import React from "react";
import { AlertTriangle, HelpCircle } from "lucide-react";

const ClarificationMessage = ({ message, onSendClarification }) => {
  const suggestions = [
    "Préciser le nom de l'employé",
    "Indiquer la période souhaitée",
    "Spécifier le département",
    "Donner plus de contexte",
  ];

  return (
    <div className="bg-amber-50 border border-amber-200 rounded-2xl p-5 mb-6 animate-fade-in">
      <div className="flex items-start space-x-3">
        <div className="flex-shrink-0 w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center">
          <HelpCircle className="w-5 h-5 text-amber-600" />
        </div>
        <div className="flex-1">
          <div className="flex items-center space-x-2 mb-2">
            <AlertTriangle className="w-4 h-4 text-amber-600" />
            <h4 className="font-semibold text-amber-900">Précision nécessaire</h4>
          </div>
          <p className="text-sm text-amber-800 mb-4">
            {message || "Je n'ai pas bien compris votre demande. Pourriez-vous me donner plus de précisions ?"}
          </p>
          
          <div className="space-y-2">
            <p className="text-xs font-medium text-amber-700">Suggestions :</p>
            <div className="flex flex-wrap gap-2">
              {suggestions.map((suggestion, index) => (
                <button
                  key={index}
                  onClick={() => onSendClarification(suggestion)}
                  className="px-3 py-1.5 bg-white border border-amber-300 text-amber-700 rounded-lg text-sm hover:bg-amber-100 transition-colors"
                >
                  {suggestion}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClarificationMessage;
